import { SESSION_STORAGE_KEYS } from 'common/constants/constants';
import { ALL_TEAMS_OPTION } from './views/CustomReport/Filters/TeamsDropdown';
import { FILTER_BY, GRANULARITY } from './views/CustomReport/consts';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';

const findTeamsById = (teams, selectedTeamsIds) => {
  const foundTeams = [];

  // Iterate over the array of teams
  for (let i = 0; i < teams.length; i++) {
    const currentTeam = teams[i];

    // Check if the current team matches any of the teams IDs
    if (selectedTeamsIds.includes(currentTeam.id)) {
      foundTeams.push(currentTeam);
    }

    // Recursively search for nodes in the children of the current node
    if (currentTeam.children && currentTeam.children.length > 0) {
      const childNodes = findTeamsById(currentTeam.children, selectedTeamsIds);
      foundTeams.push(...childNodes);
    }
  }

  return foundTeams;
};

export const filtersDefaultsMap = ({
  selectedTeam,
  treeTeamsFromRoot,
  contributors,
  selectedGlobalDateRange,
  defaultReposIds,
  defaultServicesIds
}) => {
  const defaultSelectedTeams = selectedTeam
    ? Array.isArray(selectedTeam)
      ? selectedTeam
      : [selectedTeam]
    : [ALL_TEAMS_OPTION.value];
  return {
    teams: {
      defaultValue: defaultSelectedTeams,
      toQs: teams =>
        typeof teams === 'string'
          ? teams
          : teams
              ?.flatMap(team => team)
              .map(team => team?.id ?? team)
              .join(','),
      fromQs: qs => Number(qs)
    },
    iteration_id: {
      defaultValue: null,
      toQs: iteration => iteration,
      fromQs: iteration => iteration
    },
    globallySelectedTeams: {
      defaultValue: defaultSelectedTeams,
      toQs: teams =>
        typeof teams === 'string'
          ? teams
          : teams
              ?.flatMap(team => team)
              .map(team => team?.id ?? team)
              .join(','),
      fromQs: qs => {
        const qsTeamsIds = qs
          .split(',')
          .map(team => Number(team))
          .filter(id => !isNaN(id));
        return findTeamsById(treeTeamsFromRoot, qsTeamsIds);
      }
    },
    selectedLabels: {
      defaultValue: [],
      toQs: labels => (labels.length ? labels : null),
      fromQs: qs => qs.split(',').map(label => label)
    },
    selectedRepo: {
      defaultValue: defaultReposIds || [],
      toQs: (repos = []) => (repos?.length ? repos : null),
      fromQs: qs => qs.split(',').map(repo => parseInt(repo))
    },
    selectedContributor: {
      defaultValue: null,
      toQs: contributor => contributor?.id,
      fromQs: qs => qs.split(',').map(id => contributors[id])[0]
    },
    selectedService: {
      defaultValue: defaultServicesIds || [],
      toQs: (services = []) => (services?.length ? services : null),
      fromQs: qs => qs.split(',').map(service => parseInt(service))
    },
    filterType: {
      defaultValue: FILTER_BY.PEOPLE,
      toQs: qs => qs,
      fromQs: qs => qs
    },
    selectedGranularity: {
      defaultValue: GRANULARITY.AUTO,
      toQs: qs => qs,
      fromQs: qs => qs
    },
    selectedTimeRanges: {
      defaultValue:
        JSON.parse(
          BrowserStorageAccessor().session.get(
            SESSION_STORAGE_KEYS.CUSTOM_DASHBOARD_TIMEFRAME
          )
        ) || selectedGlobalDateRange,
      toQs: value => `${value.start_date},${value.end_date}`,
      fromQs: qs => {
        const elements = qs.split(',');
        return { start_date: elements[0], end_date: elements[1] };
      }
    }
  };
};
